import React, { FC, useContext, useState } from "react";
import { Button, Empty } from "../../Base";
import CreateCoachAssetsModal from "../../../Components/Modal/CreateCoachAssetsModal";
import { Modal } from "../../../Components/Modal";
import { CoachImageType } from "../../../Structures";
import { LoadingContext } from "../../../Context";
import { Toast } from "../../../Utils";
import { TransactionDeleteCoachGallery } from "../../../Services/Transactions";

interface IProps {
  onSubmit: () => void;
  imagesList: CoachImageType[];
}

const CoachGallery: FC<IProps> = ({ onSubmit, imagesList }) => {
  const { setLoading } = useContext(LoadingContext);

  // ================================================================================================================

  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [selectedAsset, setSelectedAsset] = useState<string | null>(null);

  // ================================================================================================================

  const handleDeleteAssets = (id: CoachImageType["id"]) => {
    setLoading(true);
    TransactionDeleteCoachGallery({ id })
      .then(({ data: res }) => {
        if (res.transaction_status) {
          onSubmit();
          Toast("success", res.message);
        } else {
          Toast("error", res.message);
        }
      })
      .finally(() => setLoading(false));
  };

  // ================================================================================================================

  return (
    <div className="card border mb-4">
      <div className="card-header border-bottom d-flex align-items-center justify-content-between p-3">
        <h4 className="card-header-title mb-0">گالری</h4>
        <Button
          btnClass="btn-primary w-25px h-25 mb-0"
          onClick={() => setShowAddModal(true)}
        >
          <i className="fa fa-plus-circle" />
        </Button>
      </div>
      <Empty
        data={imagesList}
        isLoading={false}
        description="در حال حاضر عکسی آپلود نکردید"
      >
        <div className="card-body">
            <div className="row mb-4 w-100">
              {imagesList.map((image) => (
                <div key={image.id} className="col-lg-4 col-md-6 col-12 mt-3">
                  <div
                    className="text-center mx-auto border border-primary rounded-3 overflow-hidden position-relative"
                    style={{ height: 175 }}
                  >
                    <img
                      className="h-100 w-100 object-fit-cover"
                      src={image.image}
                      alt={image.id.toString()}
                    />
                    <div className="position-absolute z-index-100 top-0 w-100 h-100 p-2 d-flex justify-content-between align-items-end">
                      <Button
                        btnClass="btn-white w-25px h-25px p-0"
                        onClick={() => handleDeleteAssets(image.id)}
                      >
                        <i className="fa fa-trash text-danger" style={{ fontSize: 14 }} />
                      </Button>
                      <Button
                        btnClass="btn-white w-25px h-25px p-0"
                        onClick={() => setSelectedAsset(image.image)}
                      >
                        <i
                          className="fa fa-search-plus text-primary"
                          style={{ fontSize: 14 }}
                        />
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
      
        </div>
      </Empty>

      {showAddModal ? (
        <CreateCoachAssetsModal
          onClose={() => setShowAddModal(false)}
          onSubmit={onSubmit}
        />
      ) : null}

      {selectedAsset ? (
        <Modal close={() => setSelectedAsset(null)}>
          <div className="z-index-99 bg-transparent overflow-hidden mw-520 mb-4">
            <div className="overflow-hidden position-relative rounded-3">
              <img className="card-img" src={selectedAsset} alt="Card image" />
            </div>
          </div>
        </Modal>
      ) : null}
    </div>
  );
};

export default CoachGallery;
